<template>
<div class="select-users-form">
    <message-box></message-box>
    <div class="user-list-container attached-users">
        <div v-for="(user, index) in baseUsers" :key="index"
             class="user-block"
             :title="trans.elements.attached"
             >

            <div class="user-icon">
                <img v-if="user.photo" :src="user.photo" />
                <div v-else class='user-icon-cork'></div>
            </div>

            <div class="delete-btn-wrapper">
                <i class="fas fa-check-circle has-text-success is-size-5"></i>
            </div>

            <div class="user-data-wrapper">
                <div class="user-name">{{ user.name }}</div>
                <div class="user-email">{{ user.email }}</div>
            </div>

        </div>
    </div>

    <div class="user-list-container selected-users mt-3 ">
        <div v-for="(user, index) in selectedUsers" :key="index"
             class="user-block"
             >

            <div class="user-icon">
                <img v-if="user.PERSONAL_PHOTO" :src="user.PERSONAL_PHOTO" />
                <div v-else class='user-icon-cork'></div>
            </div>

            <div class="delete-btn-wrapper" >
                <div @click="deleteUser(index)">
                    <i class="fas fa-times-circle is-size-5 text-danger"
                       :title="trans.elements.exclude"></i>
                </div>
            </div>

            <div class="user-data-wrapper">
                <div class="user-name">{{ user.NAME }} {{ user.LAST_NAME }}</div>
                <div class="user-email">{{ user.EMAIL }}</div>
            </div>

        </div>
    </div>

    <div class="button-container">
        <input type="button"
               :value="trans.elements.select_users"
               class="button is-success"
               @click="getUsers"/>
        <input type="button"
               :value="saveNextButtonText"
               class="button is-info"
               @click="saveUsers"/>
    </div>

    <div class='modal' :class="modalIsOpenClass">
        <div class="modal-background" @click="modalIsOpenClass=''"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <span class="icon has-text-white">
                        <i class="fas fa-exclamation-triangle"></i>
                    </span>
                    &nbsp; &nbsp;
                    {{ trans.elements.attention }}
                </p>
                <button class="delete" aria-label="close" @click="modalIsOpenClass=''"></button>
            </header>
            <section class="modal-card-body">
                <p>
                    {{ replaceMessageWildcats(trans.msg.users_not_selected) }}
                </p>
                <hr/>
                <div class="has-text-centered">
                    <button class="button is-success" @click="modalIsOpenClass='';">
                        {{ trans.elements.return_and_select_users }}</button>
                    <button class="button is-danger" @click="goToBase">
                        {{ trans.elements.continue_alone }}</button>
                </div>
            </section>
            <footer class="modal-card-foot"></footer>
        </div>
        <button class="modal-close is-large"
                aria-label="close"
                @click="modalIsOpenClass=''"></button>
    </div>
</div>
</template>

<script>

import * as bx24Users from '../../modules/bx24helpers/users';
import {mapActions, mapGetters } from 'vuex';

export default {
    props: {
        // Локализация
        trans: Object,
    },
    data() {
        return {
            // Юзеры, выбранные админом, но не отправленные на сервер
            selectedUsers: [],
            /*
             * Юзеры, которых только что привязали к базе, но они уже были созданы
             * Им просто уведомление, что им открыта база
             */
            updatedUsers: [],
            /*
             * Прикрепленные юзеры
             */
            baseUsers: [],
            /*
             * Юзеры, которым направлены приглашения зарегистрироваться
             */
            invitedUsers: [],

            modalIsOpenClass: '',
            baseName: baseName,
        };
    },
    methods: {
        // Удаляем битриксового юзера из списка выбранных
        deleteUser(index) {
            this.selectedUsers.splice(index, 1);
            resizeFrame();
        },
        goToBase() {
            location = actions.bx24Base;
        },
        // Отправляем выбранных юзеров на сервер для прикрепления к базе
        saveUsers() {
            let message = '';
            let reportName = '';
            let usersNames = [];

            if (!fromSettingsWindow && !this.selectedUsers.length) {
                BX24.scrollParentWindow(0, () => {
                    this.modalIsOpenClass = 'is-active';
                });
                return;
            }

            axios.post(actions.attach_users, { users: this.selectedUsers })
                .then(response => {
                    this.updatedUsers = response.data.updatedUsers;
                    message = this.trans.msg.attach_user_notify;
                    usersNames = [];
                    this.updatedUsers.forEach(user => {
                        user.message = this.replaceMessageWildcats(message, user);
                        usersNames.push(user.name);
                    });
                    reportName = 'Existing users have been atached:';
                    this.showAttachingReport(reportName, usersNames);
                    this.setNotifications(this.updatedUsers);

                    this.invitedUsers = response.data.invites;
                    message = this.trans.msg.invite_user_notify;
                    usersNames = [];
                    this.invitedUsers.forEach(user => {
                        user.inviteLink = `${actions.register}/?${inviteParamName}=${user.hash_id}`;
                        user.message = this.replaceMessageWildcats(message, user);
                        usersNames.push(user.name);
                    });
                    reportName = 'Users have been invited:';
                    this.showAttachingReport(reportName, usersNames);
                    this.setNotifications(this.invitedUsers);

                    sendGAEvent('Пользователи подключены');
                    location = actions.bx24Base;
                })
                .catch(error => {
                    AppUtils.showServiceError(error);
                    sendGAError('Ошибка подключения пользователей');

                    let messageData = {
                        messageText: this.trans.msg.attache_users_error,
                        cancelText: '',
                        okCallback: this.goToBase,
                    };
                    this.openMessageBox(messageData);
                });
        },
        ...mapActions('messageBox', ['openMessageBox']),
        showAttachingReport(reportName, names) {
            if (!names.length) {
                return;
            }
            AppUtils.showServiceMessage({N: reportName, U: names});
        },
        // Заменяем шаблонные переменные в сообщениях юзерам в чатик
        replaceMessageWildcats(message, user) {
            let wildCards = {
                bx24_domain: bx24domain,
                base_name: baseName,
                // TODO: Сделать более сложный плейсхолдер, так как у тестировщиков Б24 портал называется solinka.bitrix24.ru
                // link: appLink,
                app_name: appName,
            };
            if (user) {
                let userData = {
                    user_name: user.name,
                    user_email: user.email,
                    user_password: user.password,
                    invite_ref: user.inviteLink,
                };
                wildCards = Object.assign(wildCards, userData);
            }
            let regExp = null;
            let readyMessage = message;
            for (let pattern in wildCards) {
                regExp = new RegExp(pattern, 'g');
                readyMessage = readyMessage.replace(regExp, wildCards[pattern]);
            }
            return readyMessage;
        },
        // Рассылаем битриксовым юзерам в чатик сообщения что они могут работать с базой
        setNotifications(users) {
            var partedUsers = this.divideUsers(users);
            this.divideBatches(
                partedUsers,
                function () {},
                function (user) {
                    return ['im.notify',
                        {
                            to: user.bx24_id,
                            message: user.message,
                            type: 'SYSTEM',
                        }
                    ];
                }
            );
        },
        // Открываем окно с выбором битриксовых юзеров
        getUsers() {
            BX24.selectUsers(this.onUsersSelected);
        },
        /*
         * Формируем массив выбранных юзеров для отправки запроса в BX24 с
         * целью получения подробной информации об этих юзерах с портала
         */
        onUsersSelected(users) {
            let uniqueUsers = [];
            users.forEach(function (item) {
                if (this.selectedUsers.some(function (elem) {
                    return elem.ID == item.id;
                })) {
                    return;
                }
                uniqueUsers.push(item);
            }, this);
            users = uniqueUsers;
            let partedUsers = this.divideUsers(users);
            this.divideBatches(
                partedUsers,
                this.onUserDataReceived,
                function (user) {
                    return ['user.get', { ID: user.id }];
                }
            );
        },
        /*
         * Делит массив юзеров на блоки по 50 человек для вставки в BX24.butch()
         */
        divideUsers(users) {
            let endCounter = 0;
            let startCounter = 0;
            let partedUsers = [];
            while (endCounter < users.length) {
                startCounter = endCounter;
                endCounter = ((endCounter + bx24ButchLimit) > users.length)
                    ? users.length
                    : endCounter + bx24ButchLimit;
                partedUsers.push(
                    users.slice(startCounter, endCounter)
                );
            }
            return partedUsers;
        },
        /*
         * Делит BX24.butch() на партии по 50 человек и вызывает каждую партию
         */
        divideBatches(partedUsers, batchCallback, buildBatchItemCallback) {
            var batch = [];
            partedUsers.forEach(function (item) {
                batch = [];
                for (let user of item) {
                    batch.push(
                        buildBatchItemCallback(user)
                    );
                }
                BX24.callBatch(batch, batchCallback);
            }, this);
        },
        /*
         * Из только что выбранных юзеров формирует массив this.selectedUsers,
         * контролирую при этом, чтобы не было повторов.
         */
        onUserDataReceived(result) {
            let realUsers = [];
            result.map(item => {
                if (item.answer.error || !item.answer.result.length) {
                    return;
                }

                for (let email in this.baseUsers) {
                    if (email == item.answer.result[0].EMAIL) {
                        return;
                    }
                }

                realUsers.push(item.answer.result[0]);
                return item.answer.result[0];
            });
            this.selectedUsers = this.selectedUsers.concat(realUsers);
        },
        /*
         * Получает юзеров, которые привязаны к базе, из нашего сервера
         * и формирует массив this.baseUsers
         */
        loadBaseUsers() {
            // Получаем прикрепленных юзеров из kb2
            let endpoint = actions.permissions.base;
            let baseAllUsers = [];
            axios.get(endpoint)
                .then(response => {
                    // Юзеры полученные из нашей базы
                    baseAllUsers = response.data;
                    // Получаем всех юзеров с портала
                    return new Promise((resolve, reject) => {
                        bx24Users.all(resolve, reject);
                    });
                })
                // находим фотки юзеров, которые есть в bx24
                .then(bx24AllUsers => {
                    // bx24AllUsers - юзеры из Битрикса
                    for (let email in baseAllUsers) {
                        baseAllUsers[email].photo = false;
                        bx24AllUsers.forEach(bx24user => {
                            if (email == bx24user.EMAIL) {
                                baseAllUsers[email].photo = bx24user.PERSONAL_PHOTO;
                            }
                        });
                    }
                    this.baseUsers = baseAllUsers;
                })
                .catch(error => {
                    AppUtils.showServiceError(error);
                });
        },
    },
    computed: {
        saveNextButtonText() {
            if (fromSettingsWindow) {
                return this.trans.elements.save_users;
            }
            return this.trans.elements.go_to_base;
        },
    },
    created() {
        this.loadBaseUsers();
    }
};

</script>
